<template>
  <v-btn 
      @click.stop
      depressed 
      small
      :color="color!==undefined ? color : 'grey lighten-3'"
      :href="`/panel/user/${type!==undefined ? type : 'client'}/${user.id}/`" target="_blank">
      <span class="mr-1">{{$tools.userFullName(user,short!==undefined ? true : false)}}</span>
      <v-icon small>mdi-open-in-new</v-icon>
  </v-btn>
</template>

<script>

export default {
  props: [
    'type',
    'user',
    'short',
    'color'
  ]
}
</script>